import React, {useState, useRef} from 'react';
import ReactCrop from 'react-image-crop';

const PageHeaderImgCrop = props => {
    const {imageSrc, imageCrop, minHeight = 0, minWidth = 0, updateCropCallback} = props;
    const [crop, setCrop] = useState();
    const [scale, setScale] = useState(1);
    const imgRef = useRef(null);

    const handleImageLoad = event => {
        const image = imgRef.current;
        const newScale = (image.width / image.naturalWidth);
        setScale(newScale);
        if (imageCrop) {
            let imageCropFormated = imageCrop;
            if (typeof imageCrop === 'string') imageCropFormated = JSON.parse(imageCrop);
            setCrop({
                unit: 'px',
                height: imageCropFormated.height * newScale,
                width: imageCropFormated.width * newScale,
                x: imageCropFormated.x * newScale,
                y: imageCropFormated.y * newScale,
            });
        } else {
            setCrop({
                unit: 'px',
                height: image.height,
                width: image.width,
                x: 0,
                y: 0,
            });
        }
    };

    const processCrop = (crop) => {
        if (!crop || !imgRef.current) return;
        const image = imgRef.current;

        let cropX = crop.x / scale;
        let cropY = crop.y / scale;
        let cropWidth = crop.width / scale;
        let cropHeight = crop.height / scale;

        if (cropWidth <= 0 || cropHeight <= 0) {
            cropX = 0;
            cropY = 0;
            cropWidth = image.naturalWidth;
            cropHeight = image.naturalHeight;
        }

        updateCropCallback({
            unit: 'px',
            x: cropX,
            y: cropY,
            width: cropWidth,
            height: cropHeight
        });
    }

    return (
        <div className="ch-s_ed-headerCrop">
            <ReactCrop
                minHeight={minHeight * scale}
                minWidth={minWidth * scale}
                crop={crop}
                onChange={(crop) => setCrop(crop)}
                onComplete={(crop) => processCrop(crop)}
            >
                <img
                    ref={imgRef}
                    src={`data:image/jpeg;base64,${imageSrc}`}
                    style={{maxWidth: '100%'}}
                    onLoad={handleImageLoad}
                />
            </ReactCrop>
        </div>
    )
}

export const generateCropPreview = async (headerImage) => {
    const { crop, masterUri } = headerImage;
    if (!masterUri) return null;

    let cropCoords = null;
    if (crop) {
        try {
            cropCoords = typeof crop === 'string' ? JSON.parse(crop) : crop;
        } catch (e) {
            console.error("Crop parse error", e);
        }
    }

    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const width = (cropCoords?.width && typeof cropCoords.width === 'number')
                ? cropCoords.width
                : img.naturalWidth;

            const height = (cropCoords?.height && typeof cropCoords.height === 'number')
                ? cropCoords.height
                : img.naturalHeight;

            const x = (cropCoords?.x && typeof cropCoords.x === 'number') ? cropCoords.x : 0;
            const y = (cropCoords?.y && typeof cropCoords.y === 'number') ? cropCoords.y : 0;

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, x, y, width, height, 0, 0, width, height);

            resolve(canvas.toDataURL('image/png'));
        };

        img.src = masterUri.startsWith('data:') ? masterUri : `data:image/jpeg;base64,${masterUri}`;
    });
};

export default PageHeaderImgCrop;